
<template>
<span
    class="icon"
    :class="{'icon--circle': hasCircle === true}"
>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        :width="width"
        :height="height"
        :viewBox="viewBox"
        :aria-labelledby="iconName"
        role="presentation"
    >
        <title
            :id="iconName"
            lang="en"
        >{{ iconName }} icon</title>
        <g :class="'icon__container ' + iconColor">
            <slot />
        </g>
    </svg>
</span>
</template>

<script>
export default {
    props: {
        // defines the icon name
        iconName: {
            type: String,
            default: 'box'
        },
        // defines icon width
        width: {
            type: [Number, String],
            default: 18
        },
        // defines icon height
        height: {
            type: [Number, String],
            default: 18
        },
        // defines the icon color, which is $studios-light-gray by default
        iconColor: {
            type: String,
            default: 'fill--gray'
        },
        // if you want the icon within a circle or not
        hasCircle: {
            type: Boolean,
            default: true
        },
        viewBox: {
            type: String,
            default: '0 0 18 18'
        }
    }
};
</script>

<style lang="scss" scoped>
@import '~/assets/styles/scss/abstracts/variables';

.icon--circle {
    border: 1px solid $studios-gray;
    border-radius: 50%;
    padding: 10px;
    height: 40px;
    width: 40px;
}

.fill--white {
    fill: white;
}

.fill--none {
    fill: unset;
}

.fill--transparent {
    fill: transparent;
}

.fill--gray {
    fill: $studios-gray;
}

.fill--green {
    fill: $studios-green;
}

.fill--red {
    fill: $studios-red;
}
</style>
